// SceneForm.form.js
import * as Yup from "yup";

export function initialValuesTwo(moduleData) {
  return {
    ModOneTitle: moduleData?.ModOneTitle || "",
    ModOneIntroduction: moduleData?.ModOneIntroduction || "",
    ModOneObjetives: moduleData?.ModOneObjetives || "",
    ModOneLevels: moduleData?.ModOneLevels || "",
  };
}

// Validation Schema
export function validationSchemaTwo() {
  return Yup.object({
    ModOneTitle: Yup.string().required("El título es obligatorio"),
    ModOneIntroduction: Yup.string().required("La introducción es obligatoria"),
    ModOneObjetives: Yup.string().required("Los objetivos son obligatorios"),
    ModOneLevels: Yup.string().required("Los levels son obligatorios"),
  });
}
